export class UnknownServerOrConnectionError extends Error {
  public override message = 'UNKNOWN SERVER OR CONNECTION ERROR!';
}
